function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 26,
  stroke: "#f54865",
  strokeWidth: 3
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 40l24-24M40 40L16 16",
  stroke: "#f54865",
  strokeWidth: 3
});

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "d23b190bd8e1f743cafffd22e7d3e081.svg";
export { SvgError as ReactComponent };